(function () {
  'use strict';

  var ORIGINAL_QUERY_PARAM = 'easyusa_q';

  function looksLikeSkuCode(value) {
    return /^[a-z0-9][a-z0-9-]*$/i.test(value);
  }

  // Previously this expanded a bare-digit or partial-SKU query (e.g. "8810")
  // into a big `q=8810* OR A8810* OR B8810* OR ...` guess across every known
  // store prefix, to work around Shopify's older search only matching whole
  // tokens. As of the store's current search engine, that `OR`-joined query
  // form returns zero results outright — confirmed directly against
  // /search/suggest.json, where even a single correct term OR'd with one
  // wrong guess (e.g. "8810* OR A8810*") comes back empty, while the same
  // store's search already resolves the plain, unmodified query ("8810"
  // alone finds all 4 S8810 variants; "1185" alone finds all 3 real matches)
  // and a single trailing wildcard on a full code still helps ("S8810*",
  // "BB2603-A*", "T2-111*" all return complete, correct results). So: pass
  // digit-led queries through unchanged, and only add a single wildcard
  // (no OR, no hyphen-guessing) when the query already mixes letters and
  // digits — never build a multi-term OR query, since that's what breaks.
  function normalizeSkuQuery(query) {
    var normalizedQuery = String(query || '').trim();

    if (!normalizedQuery || normalizedQuery.indexOf('*') !== -1 || /\s+OR\s+/i.test(normalizedQuery)) {
      return normalizedQuery;
    }

    if (!looksLikeSkuCode(normalizedQuery)) {
      return normalizedQuery;
    }

    if (/^\d/.test(normalizedQuery)) {
      return normalizedQuery;
    }

    if (/[a-z]/i.test(normalizedQuery) && /\d/.test(normalizedQuery)) {
      return normalizedQuery + '*';
    }

    return normalizedQuery;
  }

  function syncOriginalQuery(form, rawQuery, expandedQuery) {
    var originalInput = form.querySelector('input[name="' + ORIGINAL_QUERY_PARAM + '"]');

    if (expandedQuery === rawQuery) {
      if (originalInput) originalInput.remove();
      return;
    }

    if (!originalInput) {
      originalInput = document.createElement('input');
      originalInput.type = 'hidden';
      originalInput.name = ORIGINAL_QUERY_PARAM;
      form.appendChild(originalInput);
    }

    originalInput.value = rawQuery;
  }

  function normalizeSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/search"]')) return;

    var queryInput = form.querySelector('input[name="q"]');
    if (!(queryInput instanceof HTMLInputElement)) return;

    var rawQuery = queryInput.value.trim();
    var expandedQuery = normalizeSkuQuery(rawQuery);

    queryInput.value = expandedQuery;
    syncOriginalQuery(form, rawQuery, expandedQuery);
  }

  function colorStyle(product, variant) {
    var options = product.options || [];
    var names = options.map(function (option) { return String(option.name || option).toLowerCase(); });
    var colorIndex = names.findIndex(function (name) { return /colou?r/.test(name); });
    var colorValue = colorIndex < 0 ? '' : String(variant['option' + (colorIndex + 1)] || (variant.options || [])[colorIndex] || '');
    var codeMatch = colorValue.match(/\(([^()]+)\)\s*$/);
    var sku = String(variant.sku || '').trim();
    if (codeMatch) {
      sku = codeMatch[1].trim();
    } else if (names.some(function (name) { return name.indexOf('size') !== -1; })) {
      sku = sku.replace(/-(?:\d+(?:\.\d+)?(?:TO\d+(?:\.\d+)?)?|XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/i, '');
    }
    return { sku: sku, color: colorValue.split('(')[0].trim() };
  }

  function matchColorVariant(product, query) {
    var term = String(query || '').trim().replace(/\*/g, '').toLowerCase();
    if (term.length < 3 || !/\d/.test(term)) return null;
    var result = null;
    var ambiguous = false;
    (product.variants || []).forEach(function (variant) {
      var style = colorStyle(product, variant);
      var sku = style.sku.toLowerCase();
      var numericSku = sku.replace(/^[^0-9]*/, '');
      if (!sku.startsWith(term) && !numericSku.startsWith(term) && String(variant.sku || '').toLowerCase() !== term) return;
      if (result && result.sku.toLowerCase() !== sku) ambiguous = true;
      if (!result) result = { variant: variant, sku: style.sku, color: style.color };
    });
    return ambiguous ? null : result;
  }

  window.EasyUSASearch = window.EasyUSASearch || {};
  window.EasyUSASearch.colorStyle = colorStyle;
  window.EasyUSASearch.matchColorVariant = matchColorVariant;
  window.EasyUSASearch.normalizeSkuQuery = normalizeSkuQuery;
  window.EasyUSASearch.originalQueryParam = ORIGINAL_QUERY_PARAM;

  document.addEventListener('submit', function (event) {
    normalizeSearchForm(event.target);
  }, true);
}());
